// Imports of the module
import { parseDate } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

// Enum mappings from Ruby
const sourceEnumMap: { [key: number]: string } = {
  0: "Fred",
  1: "World Bank",
};

const frequencyEnumMap: { [key: number]: string } = {
  0: "Annual",
  1: "Biweekly",
  2: "Daily",
  3: "Monthly",
  4: "Quarterly",
  5: "Semiannual",
  6: "Weekly",
};

// Type of the fields in the table
export type FinancialIndicator = {
  id: number;
  code: string;
  source?: number | null;
  short_name: string;
  name: string;
  country: string;
  frequency?: number | null;
  created_at: string;
  updated_at: string;
};

// Definition of the columns
export const financial_indicator_columns: ColumnDef<FinancialIndicator>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "code",
    header: "Code",
  },
  {
    accessorKey: "source",
    header: "Source",
    cell: ({ row }) => {
      const value = row.getValue<number | null>("source");
      return value != null ? sourceEnumMap[value] || value : "";
    },
  },
  {
    accessorKey: "short_name",
    header: "Short Name",
  },
  {
    accessorKey: "name",
    header: "Name",
  },
  {
    accessorKey: "country",
    header: "Country",
  },
  {
    accessorKey: "frequency",
    header: "Frequency",
    cell: ({ row }) => {
      const value = row.getValue<number | null>("frequency");
      return value != null ? frequencyEnumMap[value] || value : "";
    },
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => {
      return parseDate(row.getValue<string>("created_at"));
    },
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => {
      return parseDate(row.getValue<string>("updated_at"));
    },
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => {
      return (
        <div className="flex justify-end">
          <Link
            href={`${window.location.pathname}/${row.getValue("id")}`}
            className="text-xs"
            underline="hover"
          >
            {i18n.t("actions.edit")}
          </Link>
        </div>
      );
    },
  },
];
